import React, { Component } from 'react';
import Icon from '../components/Icon';

class ResultPage extends Component{

    constructor(props){
        super(props);

        this.state = {
            winners:[]
        };

        this.handleGoToShare= this.handleGoToShare.bind(this);
    }

    componentWillMount(){
        var winners = this.getWinners();
        this.props.handleGetWinners(winners);
        this.setState({
           winners:winners
        });
    }

    componentDidMount(){
        this.saveResult();
    }

    saveResult(){
        if(typeof this.props.saveResultCallback === 'function') {
            var email = this.props.userEmail !== '' ? this.props.userEmail : 'anonymous@mail.com';
            var answersString = this.props.answers.join('-');
            var optinsString = '';
            if(this.props.optins.length > 0) {
                optinsString = this.props.optins.join('-');
            }
            var params = {
                email: email,
                winner: this.state.winners[0].label,
                answers: answersString,
                optins: optinsString
            };
            this.props.saveResultCallback.call(null, params);
        }
    }

    handleGoToShare(evt){
        this.props.handleGoToShare.call();
    }

    render(){
        var banner = '';
        if(this.props.imgBanner !== ''){
            banner = this._getLogoWithBanner();
        }else{
            banner = this._getLogoWithoutBanner();
        }

        var button = '';
        if(this.state.winners[0].url != ''){
            button = (<a href={this.state.winners[0].url} target="_blank" className="isg_partner_link"><Icon value="icon_arrow" /> En savoir plus</a>);
        }else if(this.props.url !== ''){
            button = (<a href={this.props.url} target="_blank" className="isg_partner_link"><Icon value="icon_arrow" /> En savoir plus</a>);
        }

        return(
            <div className="isg_panel isg_result_page isg_bg_base">
                <div className="isg_panel_content">
                    {banner}
                    <div className="isg_result_winner">
                        <div className="isg_winner_content">
                            <div className="isg_winner_face_icon">
                                <img src={this.state.winners[0].img} alt="" />
                            </div>
                            <div className="isg_winner_infos">
                                <div className="isg_winner_name">{this.state.winners[0].label}</div>
                                <div className="isg_winner_scrollbar">
                                    <p dangerouslySetInnerHTML={{__html:this.state.winners[0].description}}></p>
                                </div>
                                {button}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="isg_bottom_box">
                    <div className="isg_panel_content">
                        <span onClick={this.props.handleRestart}><Icon value="icon_rejouer" /> Rejouer</span>
                        <span onClick={this.handleGoToShare}><Icon value="icon_partager" /> Partager</span>
                        <span onClick={this.handleGoToShare}><Icon value="icon_inviter" /> Inviter</span>
                    </div>
                </div>
            </div>
        );
    }

    _getLogoWithBanner(){
        return (
            <div className="isg_logo">
                <img src={this.props.imgBanner} alt="" />
            </div>
        );
    }

    _getLogoWithoutBanner(){
        return (
            <div className="isg_logo"></div>
        );
    }

    getWinners(){
        var answersCount = [];
        var allAnswers = this.props.answers;

        this.props.resultList.forEach(function(result){
            answersCount.push({
                id: result.id,
                label: result.label,
                description: result.description,
                img: result.img,
                url: result.url,
                score: 0
            });
        });

        this.props.questionList.forEach(function(question, index){
            var currentAnswer = allAnswers[index];
            question.answerList[currentAnswer].resultList.forEach(function(winner){
                answersCount.forEach(function(item, itemIndex){
                    if(item.id === this.id){
                        //item.score += Number.isNaN(winner.weight) ? 1 : Number(winner.weight);
                        if(isNaN(winner.weight)){
                            item.score += 20;
                        }else{
                            item.score += Number(winner.weight);
                        }
                        answersCount[itemIndex] = item;
                    }
                }, winner);
            });
        });

        answersCount.sort(function(a, b){
            if(a.score > b.score){
                return -1;
            }
            if(a.score < b.score){
                return 1;
            }
            return 0;
        });

        return answersCount;
    }
}

ResultPage.propTypes = {
    resultList: React.PropTypes.array.isRequired,
    questionList: React.PropTypes.array.isRequired,
    answers: React.PropTypes.array.isRequired,
    optins: React.PropTypes.array,
    handleRestart: React.PropTypes.func.isRequired,
    saveResultCallback: React.PropTypes.func,
    handleGetWinners: React.PropTypes.func.isRequired,
    handleGoToShare: React.PropTypes.func.isRequired,
    userEmail: React.PropTypes.string.isRequired,
    imgBanner: React.PropTypes.string,
    url: React.PropTypes.string
};

export default ResultPage;


/** WEBPACK FOOTER **
 ** ./src/components/ResultPage.js
 **/